import {useTranslation} from 'react-i18next';
import * as css from '../../dateStep/dateTopStep/DateTopStep.css';
import {useField} from 'formik';
import {tsToDate} from '../../../../../library/dates';
import {useSelector} from 'react-redux';

function SimpleDateTopStep() {
    const {t} = useTranslation('newEvent');

    const [dateField]=useField('date');
    // const [{value:timezone}]=useField('locale.timeZone');
    const timezone=useSelector(s=>s.event.timeZone);
    const {startDate,endDate}=dateField.value;
    return (
        <css.wrapper>
            <css.startText>{t('start')}</css.startText>
            <css.startDate>
                {tsToDate(startDate,'',timezone)}
            </css.startDate>
            <css.endText>{t('end')}</css.endText>
            <css.endDate>
                {tsToDate(endDate,'',timezone)}
            </css.endDate>
        </css.wrapper>

    );
}

export default SimpleDateTopStep;
